<template>
  <div class="py-2 my-2 help-container">
    <h1 class="separator py-4">IMPORT</h1>
    <span class="banner py-3 mb-4">
      <div>The Import option will allow you to import a budget from excel in CSV (Comma Separated Value) format. You will be able to import into an existing budget or create a new budget.</div>
      <div>Note: If the status of the existing budget is Submitted for Approval, Pending Approved, Approved or Published, the import option will not be available.</div>
      <div>Expand the topic below for more information on that step.</div>
    </span>

    <!--Help Sections-->
    <v-expansion-panels v-model="openSectionInternal">
      <v-expansion-panel>
        <v-expansion-panel-header :color="getSectionColorFor(0)">
          <v-icon small class="icon" slot="actions" :color="getIconColorFor(0)">$vuetify.icons.expand</v-icon>
          <span class="header pl-3"><strong>Import</strong></span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="help-content">
          <div>Once you select Import, the popup screen will describe the required data for each column. Your spreadsheet can have no formulas, titles, or totals. It <u>must</u> be formatted with the exact 14 columns shown below with no other data. If your spreadsheet does not follow these rules, you will receive errors when importing.</div>
          <div>Note: You can import rows that have all zeros without causing any problems.</div>
          <img src="../../assets/help/import1.png" />
          <div><strong>Important Note:</strong></div>
          <div>When a budget is created, some GL Accounts will be automatically populated based on defaults from the Market Rent and Occupancy worksheets. Example GL Accounts are Gross Potential Rent, Vacancy Loss and Gain/Loss to Lease.</div>
          <div>When you Import budget information, only the GL Accounts in your import spreadsheet will be affected.</div>
          <div>Example: If you did not import anything for Gain/Loss To Lease, there will still be numbers in that GL Account created previously from the Occupancy worksheets default information.</div>
          <div>If you want every number in the budget to be overwritten, make sure to include every GL Account in your import spreadsheet.</div>
          <div><strong>Note about creating a new budget</strong>: If an existing budget exists with the matching Property, Year, and Accounting Basis, the Start Month used will be the Start Month already set for that Budget, not the Starting Month entered on the Import dialog, as that value is used also to line up the monthly values on the import.</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Prefer to watch a video? <a @click="openExternalTopic('BudgetsPro Import Budgets')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
      <v-expansion-panel readonly>
        <v-expansion-panel-header>
          <v-icon slot="actions"></v-icon>
          <span class="black--text pointer">Want to see all BudgetsPro help articles? <a @click="openExternalTopic('BudgetsPro')">Click Here</a></span>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import HelpMixin from '@/mixins/Help.js'
  export default {
    name: 'ImportBudgetHelp',
    mixins: [HelpMixin]
  }
</script>

<style lang="scss" scoped>
  .no-bullet {
    list-style-type: none;
  }
  .icon {
      order: 0;
  }
  .header {
      order: 1;
  }
  img {
    max-width: 650px;
  }
  img.small {
    width: 35px;
  }
  .help-container {
      border-bottom: 1px solid var(--v-resGrey-lighten1)
  }
  .help-content div,
  .help-content li {
      margin-top:10px !important;
      margin-bottom:10px !important;
  }
  .banner {
    text-align: center;
    background-color: var(--v-resGrey-lighten1);
    display: block;
  }
  .pointer {
      cursor: pointer !important;
  }
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid var(--v-resGrey-darken1);
  }

  .separator:not(:empty)::before {
    margin-right: .25em;
  }

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
